import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';
import { TakeawayServices } from '../../../takeaway/services';
import { AngularFirestore } from 'angularfire2/firestore';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-deliveries-create',
  templateUrl: 'configuration-deliveries-create.html',
})
export class ConfigurationDeliveriesCreatePage {

  public form: FormGroup;
  public firestore: any;

  update_state: boolean = false;
  delivery: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    public takeawayServices: TakeawayServices,
    public afs: AngularFirestore) {
    this.firestore = firebase.firestore();
    //Params
    this.update_state = this.navParams.get('update_state');
    this.delivery = this.navParams.get('delivery');

    if (this.navParams.get('update_state')) {
      this.form = fb.group({
        name: [this.delivery.name, Validators.compose([Validators.required])],
      });

    } else {
      this.form = fb.group({
        name: ['', Validators.compose([Validators.required])],
      });
    }
    this.takeawayServices.getDeliveriesFavorites();
  }

  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('configuracion-introduce-nombre-delivery'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {
    this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries').add({
      'name': this.form.value.name,
    }).then(doc => {
      //Añadimos el elemento al array
      let _obj = { 'name': this.form.value.name, 'img': undefined };
      this.takeawayServices.deliveries.push(_obj);
      //this.globals.GAtrackView('Configuration', 'Configuration - Cashs - Create', this.globals.restaurant.email, 'Create/Update', 'Create cash', 'Configuration', this.form.value.name);
      this.navCtrl.pop();
    });
  }

  update() {
    this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries').doc(this.delivery.UID).update({
      'name': this.form.value.name,
    }).then(() => {

      //Revisamos que el delivery que vamos a actualizar no este en la subcolection de favoritos
      this.takeawayServices.deliveries.forEach(fav_delivery => {
        if (this.delivery.name == fav_delivery.name) {
          //en caso de que este lo eliminamos de la subcolection lo actualizamos
          this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries_favorites').doc(fav_delivery.favorites_UID).update({
            'name': this.form.value.name,
          }).then(() => { });
        }
      });

      //Modificamos el listado
      this.takeawayServices.deliveries.find(t => t.name == this.delivery.name).name = this.form.value.name;
      //this.globals.GAtrackView('Configuration', 'Configuration - Cashs - Update', this.globals.restaurant.email, 'Create/Update', 'Update cash', 'Configuration', this.form.value.name);     
      this.navCtrl.pop();
    });
  }

  delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('configuracion-eliminar-delivery'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //Revisamos que el delivery que vamos a eliminar no este en la subcolection de favoritos
            this.takeawayServices.deliveries.forEach(fav_delivery => {
              //Comprovamos si el nombre del delivery coincide y si esta en favoritos
              if (this.delivery.name == fav_delivery.name && fav_delivery.active) {
                //en caso de que este lo eliminamos de la subcolection
                this.afs.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries_favorites').doc(fav_delivery.favorites_UID).delete();
              }
            });

            //Eliminamos el elemento del array
            const found = this.takeawayServices.deliveries.map(function (e) { return e.name; }).indexOf(this.delivery.name);
            this.takeawayServices.deliveries.splice(found, 1);

            this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries').doc(this.delivery.UID).delete();
            this.navCtrl.pop();
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-deliveries/configuration-deliveries-create/configuration-deliveries-create.ts